import {
  InputGroup,
  InputRow,
  EmptyInput,
  ModelNewNumericInput,
} from '@equifinance/shared';

import { Stages } from '../../../../types/Stages';
import { PaddedSection } from '../../components/Section';
import { useAccountContext } from '../../../../contexts';

export const MortgageRefName = 'mortgage';

export default function MortgageSection() {
  const { account, creditSearchCompleted } = useAccountContext();

  const {
    stage,
    mortgage,
    errors,
    warnings,
  } = account;

  return (
    <PaddedSection
      id={mortgage?.id}
      refName={MortgageRefName}
      title="Mortgage"
      isLocked={stage === Stages.CreditDecision && creditSearchCompleted}
      errors={errors}
      warnings={warnings}
    >
      <InputGroup>
        <InputRow>
          <ModelNewNumericInput
            label="Outstanding balance"
            field="mortgage.outstandingBalance"
            prefix="£"
            disabled={creditSearchCompleted}
            isFixedDecimal
            required
          />
          <EmptyInput />
        </InputRow>
      </InputGroup>
    </PaddedSection>
  );
}
